// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
}

ion-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --box-shadow: none;
  --padding-start: 0;
  --padding-end: 0;
  margin: 0;
  min-height: 24px;
  border: none;
  --border-style: none;
}
ion-button ion-icon {
  height: 18px;
  width: 26px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;AADD;;AAIA;EACC,yBAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;AADD;AAEC;EACC,YAAA;EACA,WAAA;AAAF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: flex;\n}\n\nion-button {\n\t--background: transparent;\n\t--background-hover: transparent;\n\t--background-activated: transparent;\n\t--box-shadow: none;\n\t--padding-start: 0;\n\t--padding-end: 0;\n\tmargin: 0;\n\tmin-height: 24px;\n\tborder: none;\n\t--border-style: none;\n\tion-icon {\n\t\theight: 18px;\n\t\twidth: 26px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
